import { RecordManagement } from "app/class/record-management";
import SysRecord from "app/class/record";
import { axiosInterceptor } from "../request-interceptor";


export const PLATFORM_PACKAGE_OPERATION_TIMEOUT_PROPERTY = "prm.platform_package.operation_timeout_ms";
export const PLATFORM_PACKAGE_OPERATION_TIMEOUT_FALLBACK_MS = 120000;

const normalizePlatformPackageOperationTimeout = (value: unknown) => {
    const parsed = Number(String(value ?? "").trim());

    return Number.isFinite(parsed) && parsed > 0
        ? parsed
        : PLATFORM_PACKAGE_OPERATION_TIMEOUT_FALLBACK_MS;
};

export const getPlatformPackageOperationTimeoutMs = async () => {
    try {
        const property = await new RecordManagement<{ value?: unknown }>("sys_properties")
            .where("name", PLATFORM_PACKAGE_OPERATION_TIMEOUT_PROPERTY)
            .first();

        return normalizePlatformPackageOperationTimeout(property?.value);
    } catch (error) {
        console.warn("[PlatformPackage] Could not resolve operation timeout property", error);
        return PLATFORM_PACKAGE_OPERATION_TIMEOUT_FALLBACK_MS;
    }
};

export const platformPackageOperationRequestConfig = async () => ({
    timeout: await getPlatformPackageOperationTimeoutMs(),
});

// const getSingleRecord = async (table: string, id: string) => {
//     return axiosInterceptor.get<SysRecord>(`/api/records/${table}/${id}`);
// }

// const getRecordsByQuery = async (table: string, query: string = "", sort: string = "", direction: "asc" | "desc" = "asc") => {
//     let queryParam = encodeURIComponent(query);
//     let sortParam = encodeURIComponent(sort);
//     return axiosInterceptor.get<SysRecord[]>("/api/records/" + table + "?conditions=" + queryParam + "&sort=" + sortParam + "&direction=" + direction);
// }

const postRecord = async (table: string, record: SysRecord) => {
    return axiosInterceptor.post<SysRecord>("/api/records/" + table, record);
}

const updateRecord = async (table: string, id: string, record: SysRecord) => {
    return axiosInterceptor.put<SysRecord>(`/api/records/${table}/${id}`, record);
}

const deleteRecord = async (table: string, id: string) => {
    return axiosInterceptor.delete<SysRecord>(`/api/records/${table}/${id}`);
}

const addToPlatformPackage = async (table: string, id: string) => {
    return axiosInterceptor.post(`/api/records/${table}/${id}/add_to_package`);
}

const removeFromPlatformPackage = async (id: string) => {
    return axiosInterceptor.post(`/api/records/version_records/${id}/remove_from_package`);
}

const commitPlatformPackage = async (packageId: string) => {
    return axiosInterceptor.post(`/api/records/platform_packages/${packageId}/commit`, undefined, await platformPackageOperationRequestConfig());
}

const exportPlatformPackage = async (packageId: string) => {
    return axiosInterceptor.get(`/api/records/platform_packages/${packageId}/export`);
}

const convertPlatformPackage = async (packageId: string) => {
    return axiosInterceptor.get(`/api/records/platform_packages/${packageId}/convert`, await platformPackageOperationRequestConfig());
}

const rollbackPlatformPackage = async (packageId: string) => {
    return axiosInterceptor.post(`/api/records/platform_packages/${packageId}/rollback`, undefined, await platformPackageOperationRequestConfig());
}

const runPlatformJob = async (jobId: string) => {
    return axiosInterceptor.post(`/api/records/sys_jobs/${jobId}/run`);
}

const recordApi = { postRecord, updateRecord, deleteRecord, commitPlatformPackage, addToPlatformPackage, removeFromPlatformPackage, exportPlatformPackage, convertPlatformPackage, rollbackPlatformPackage, runPlatformJob }; //  getSingleRecord, getRecordsByQuery,
export { postRecord, updateRecord, deleteRecord, commitPlatformPackage, addToPlatformPackage, removeFromPlatformPackage, exportPlatformPackage, convertPlatformPackage, rollbackPlatformPackage, runPlatformJob }; // getSingleRecord, getRecordsByQuery,
export default recordApi;
